/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FrequencyBand {
  All = "all",
  $24 = "2.4",
  $5 = "5",
  $6 = "6",
}
